var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseCompletePage',{attrs:{"content":_vm.getCover,"hideSdnExternal":true,"showAllQuoteSummary":false,"cardTitle":'Your Rent Protection Insurance quote',"showTotalPremiumIPT":_vm.showTotalPremiumIPT,"insurancePremiumTitle":"Rent Protection premium (ex IPT)","annualTitle":"One off payment"}})
}
var staticRenderFns = []

export { render, staticRenderFns }